import {
  useQuery,
  type UseQueryOptions,
  type QueryKey,
} from "@tanstack/react-query";

import { useDiscardUnavailableData } from "@softmax/web-features/data";

export function useSearchQuery<Data, Key extends QueryKey>(
  options: UseQueryOptions<Data, Error, Data, Key>,
) {
  const query = useQuery({ ...options, retry: false });
  const unavailable = useDiscardUnavailableData({
    queryKey: options.queryKey,
    error: query.error,
  });
  return { ...query, data: unavailable ? undefined : query.data };
}
